<template>
  <div>
    <a href="#" @click="toggle">
      <slot name="toggle">
        <i class="material-icons color-is-white font-is-2">
          list
        </i>
      </slot>
    </a>

    <div :class="show ? 'is-active' : ''" class="modal">
      <div class="modal-background" @click="toggle" />
      <div class="modal-card is-full-width">
        <header class="modal-card-head">
          <p class="modal-card-title">
            <span v-html="$t('course.progress.list')" />
            <span v-if="overall" v-html="`(${overall}%)`" />
          </p>
          <button class="delete" aria-label="close" @click="toggle" />
        </header>
        <section class="modal-card-body">
          <table class="table is-striped is-fullwidth">
            <thead>
              <tr>
                <th>#</th>
                <th v-text="$t('course.progress.chapter')" />
                <th
                  class="is-right"
                  v-text="$t('course.progress.completed_at')"
                />
                <th class="is-right">
                  %
                </th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(chapter, index) in schedule" :key="index">
                <td v-text="`${index + 1}.`" />
                <td v-text="chapter.name" />
                <td class="is-right" v-text="chapter.completed_at" />
                <td class="is-right" v-text="`${chapter.progress}%`" />
              </tr>
            </tbody>
          </table>
        </section>
        <footer class="modal-card-foot">
          <button class="button" @click="toggle">
            Close
          </button>
        </footer>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Progress',

  props: {
    course_uuid: { type: String, required: true }
  },

  data() {
    return {
      schedule: [],
      overall: null,
      show: false
    };
  },

  methods: {
    get() {
      axios
        .get(`/course-progress/${this.course_uuid}`)
        .then(({ data }) => {
          this.schedule = data.data;
          this.overall = data.meta.overall;
        })
        .catch(() => {
          error('Could not get course progress. Please try again.');
        });
    },

    toggle() {
      if (!this.schedule.length) {
        this.get();
      }

      this.show = !this.show;
    }
  }
};
</script>
